import api from './api'
import endpoints from './endpoints'

const commentService = {
  /**
   * 发送评论
   * @param {string|number} postId - 帖子ID
   * @param {string} content - 评论内容
   * @param {number} rating - 评分，默认5
   * @returns {Promise} - API响应
   */
  addComment: async (postId, content, rating = 5) => {
    const res = await api.post(endpoints.comment.add(postId), {
      id: postId,
      content,
      rating
    })
    return res
  },

  createComment: async (contentId, payload) => {
    /**
     * 创建评论或回复
     * @param {string|number} contentId - 关联内容ID
     * @param {{content:string, rating?:number, reply_to_id?:string|number, reply_to_user_id?:string|number, mentions?:Array}} payload
     * @returns {Promise<object>} - 后端返回的评论对象
     */
    const body = {
      content: payload.content,
      ...(payload.rating !== undefined ? { rating: payload.rating } : {}),
      ...(payload.reply_to_id ? { reply_to_id: payload.reply_to_id } : {}),
      ...(payload.reply_to_user_id ? { reply_to_user_id: payload.reply_to_user_id } : {}),
      ...(Array.isArray(payload.mentions) && payload.mentions.length ? { mentions: payload.mentions } : {})
    }
    const res = await api.post(endpoints.comment.add(contentId), body)
    return res
  },

  /**
   * 获取评论列表（分页）
   * @param {string|number} postId - 帖子ID
   * @param {number} page - 页码
   * @param {number} perPage - 每页数量
   * @returns {Promise<{reviews:[], pagination:{}}>} - 评论和分页
   */
  getComments: async (postId, page = 1, perPage = 20, commentId) => {
    const params = { page, per_page: perPage }
    if (commentId) params.comment_id = commentId
    const res = await api.get(endpoints.comment.list(postId), { params })
    return res
  },

  getCommentReplies: async (commentId, page = 1, perPage = 100) => {
    /**
     * 获取某条评论的回复列表
     * @param {string|number} commentId - 评论ID
     * @param {number} page - 页码
     * @param {number} perPage - 每页数量
     * @returns {Promise<{replies:[], metadata:{}}>} - 回复与元数据
     */
    const res = await api.get(endpoints.comment.replies(commentId), { params: { page, per_page: perPage } })
    return res
  },

  toggleLike: async (contentId) => {
    /**
     * 切换点赞状态（支持内容、评论或回复）
     * @param {string|number} contentId - 内容或评论ID
     * @returns {Promise<{liked:boolean, like_count:number}>}
     */
    const res = await api.post(endpoints.like.toggle(contentId), {})
    return res
  }
};

export default commentService